export const ROLE_PROFESSIONAL = 'professional';
export const defaultSubscriptionPackId = process.env.REACT_APP_DEFAULT_SUBSCRIPTION_PACK_ID;
export const validRolesToUseSubscription = [ROLE_PROFESSIONAL];
export const defaultRequiredCredits = parseFloat(process.env.REACT_APP_DEFAULT_REQUIRED_CREDITS) || 3.5;
export const sessionStorageKey = 'subscription';
export const redirectAfterCheckoutTimeout = parseInt(process.env.REACT_APP_REDIRECT_TIMEOUT) || 5000;